import { FuseRouteItemType } from '@fuse/utils/FuseUtils';
import authRoles from '@auth/authRoles';
import { lazy } from 'react';

const ConfigError = lazy(() => import('./ConfigErrorPage'));

/**
 * Configuration Error Route
 * Displayed when configuration requests repeatedly fail
 */
const ConfigErrorRoute: FuseRouteItemType = {
    path: 'config-error',
    element: <ConfigError />,
    settings: {
        layout: {
            config: {
                navbar: {
                    display: false
                },
                toolbar: {
                    display: false
                },
                footer: {
                    display: false
                },
                leftSidePanel: {
                    display: false
                },
                rightSidePanel: {
                    display: false
                }
            }
        }
    },
    auth: authRoles.onlyGuest
};

export default ConfigErrorRoute;
